// extracted by mini-css-extract-plugin
export var cardBody = "style-mod--card-body--4b854";
export var cardContent = "style-mod--card-content--39627";
export var cardImg = "style-mod--card-img--eff85";
export var cardLink = "style-mod--card-link--c9f44";
export var cardTitle = "style-mod--card-title--501a1";
export var kitchenWareItemsDesktop = "style-mod--kitchen-ware-items-desktop--ee9f5";
export var kitchenWareItemsMobile = "style-mod--kitchen-ware-items-mobile--7dc03";
export var kitchenware = "style-mod--kitchenware--3674d";
export var kitchenwareCard = "style-mod--kitchenware-card--1f7a1";
export var kitchenwareContent = "style-mod--kitchenware-content--8f82c";
export var kitchenwareItems = "style-mod--kitchenware-items--89fd0";
export var kitchenwareSubtitle = "style-mod--kitchenware-subtitle--62d86";
export var kitchenwareText = "style-mod--kitchenware-text--5b18e";
export var kitchenwareTitle = "style-mod--kitchenware-title--30756";